export default __webpack_public_path__ + "static/media/info-upload-2.10d02f73.jpg";